import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
    catchError,
    filter,
    map,
    switchMap,
    tap
} from 'rxjs/operators';
import { ManagementApiService } from '../management-api.service';
import { AddLocationSetTypeDialogComponent } from '@emm/shared/dialogs/add-location-set-type-dialog/add-location-set-type-dialog.component';
import {LocationSetTypesActions} from '@emm/management/store/location-set-types/location-set-types.actions';
import {DialogService} from '@emm/shared/services/dialog.service';
import {NotificationService} from '@emm/shared/services/notification.service';

@Injectable({
    providedIn: 'root'
})
export class LocationSetTypesEffects {

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocationSetTypesActions.load),
            switchMap(() =>
                this.api.getAllLocationSetTypes().pipe(
                    map((locationSetTypes) => LocationSetTypesActions.loadSuccess({ locationSetTypes })),
                    catchError(({ error }) => of(LocationSetTypesActions.loadFailure({ error })))
                )
            )
        )
    );

    loadLocationSetTypesFromLocationSets$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocationSetTypesActions.loadFromLocationSets),
            switchMap(() =>
                this.api.getAllLocationSetTypesForEdit().pipe(
                    map((locationSetTypes) =>
                        LocationSetTypesActions.loadFromLocationSetsSuccess({ locationSetTypes })
                    ),
                    catchError(({ error }) =>
                        of(LocationSetTypesActions.loadFromLocationSetsFailure({ error }))
                    )
                )
            )
        )
    );

    openAddDialog$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocationSetTypesActions.openAddDialog),
            switchMap((_) => {
                const dialogRef = this.dialog.open(AddLocationSetTypeDialogComponent, {
                    width: '600px',
                    data: { showDelete: false },
                });

                return dialogRef.afterClosed().pipe(
                    filter((result) => result && result === 'submit'),
                    tap(() => {
                        this.notificationService.success('Added Successfully');
                    }),
                    map(() => LocationSetTypesActions.load())
                );
            })
        )
    );

    delete$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocationSetTypesActions.delete),
            switchMap(({ locationSetType }) =>
                this.dialogService
                    .openConfirmDialog('Are you sure you want to delete', locationSetType.name)
                    .afterClosed()
                    .pipe(
                        switchMap((confirmDelete) =>
                            confirmDelete
                                ? this.api.deleteLocationSetType(locationSetType.tag).pipe(
                                map(() => LocationSetTypesActions.deleteSuccess()),
                                catchError(({ error }) => of(LocationSetTypesActions.deleteFailure({ error })))
                                )
                                : of(LocationSetTypesActions.deleteFailure({ error: 'No Clicked' }))
                        )
                    )
            )
        )
    );

    deleteSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocationSetTypesActions.deleteSuccess),
            tap(() => {
                this.notificationService.success('Deleted successfully');
            }),
            switchMap(() => of(LocationSetTypesActions.load()))
        )
    );

    constructor(
        private actions$: Actions,
        private api: ManagementApiService,
        public dialog: MatDialog,
        private dialogService: DialogService,
        private notificationService: NotificationService
    ) {}

}
